export const landingData: any = {
  mapFeatures: [
    {
      icon: 'mapIcon',
      title: 'Fishing Maps',
      description:
        '20k+ community populated maps and 8k+ fishing maps with: contours, ' +
        'hot spots, access points & bottom structure provided by Fishing Hot Spots®.',
    },
    {
      icon: 'mobileIcon',
      title: 'Mobile',
      description: 'You can use Fishidy whether you\'re at home on a computer or using your phone while on the boat.',
    },
    {
      icon: 'communityIcon',
      title: 'Community',
      description:
        '325k+ saltwater, stream, river, lake and ice anglers have used Fishidy.' +
        ' From first timers to pros, young to old. The more people you follow the more activity you\'ll see.',
    },
    {
      icon: 'businessesIcon',
      title: 'Businesses',
      description:
        'Planning a trip? Find bait shops, marinas, general stores and much more. Do you have a business? Put it on the map for no cost.',
    },
    {
      icon: 'loggingIcon',
      title: 'Logging & Privacy',
      description:
        'Keep track of your catches and favorite fishing spots. ' +
        'You can always keep your activity hidden and private. Sharing is always optional.',
    },
    {
      icon: 'funIcon',
      title: 'Fun!',
      description:
        'Fishing is about making memories and having fun. Share these memories with others by adding your catch to the ' +
        'Braggin\' Board and/or your followers.',
    },
  ],
};
